<template>
    <OverlayLoader :isLoading="!paymentLoaded">
        <main class="page page-dashboard">
            <div class="container">
                <PageHeader
                    :title="$translate.text('general.payment')"
                />

                <router-link :to="{ name: 'Admin Payments' }">
                    terug naar overzicht
                </router-link>

                <div style="margin-top: 10px;">

                    <table>
                        <tbody>
                            <tr>
                                <td style="width: 300px;"><strong>{{ $translate.text('general.date') }}</strong></td>
                                <td>{{ payment.meta.created_at }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $translate.text('general.company.name') }}</strong></td>
                                <td>{{ payment.client.company_name }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $translate.text('general.subscription.option') }}</strong></td>
                                <td>{{ payment.subscription_option.type === 'yearly' ? 'Jaar' : 'Eenmalig' }} ({{ payment.subscription_option.max_sync }})</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $translate.text('general.payment.reference') }}</strong></td>
                                <td>{{ payment.payment_id }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $translate.text('general.price') }}</strong></td>
                                <td>€ {{ payment.order.calculated_price }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $translate.text('general.payment_interval') }}</strong></td>
                                <td>{{ payment.payment_interval === 'year' ? 'Per jaar' : 'Per maand' }}</td>
                            </tr>
                            <tr>
                                <td><strong>{{ $translate.text('general.status') }}</strong></td>
                                <td>{{ payment.status }}</td>
                            </tr>

                            <tr>
                                <td colspan="2">&nbsp;</td>
                            </tr>

                            <tr v-if="payment.client.reseller">
                                <td><strong>Reseller</strong></td>
                                <td>{{ payment.client.reseller.company_name }}</td>
                            </tr>
                            <tr v-if="payment.client.reseller">
                                <td><strong>Reseller provisie percentage</strong></td>
                                <td>{{ payment.client.reseller.provision }}%</td>
                            </tr>
                            <tr v-if="payment.client.reseller">
                                <td><strong>Reseller provisie</strong></td>
                                <td>€ {{ calculatedProvision }}</td>
                            </tr>

                            <tr>
                                <td colspan="2">&nbsp;</td>
                            </tr>

                            <tr>
                                <td><strong>{{ $translate.text('general.exported') }}</strong></td>
                                <td>{{ payment.exported ? 'Ja' : 'Nee' }}</td>
                            </tr>

                            <tr v-if="payment.exported">
                                <td>&nbsp;</td>
                                <td>
                                    <a @click="unmarkAsExported">
                                        ongedaan maken
                                    </a>
                                </td>
                            </tr>



                        </tbody>
                    </table>
                </div>


            </div>
        </main>
    </OverlayLoader>
</template>
<script>
import handleError from '@/helpers/error';
import OverlayLoader from '@/components/OverlayLoader/OverlayLoader';
import PageHeader from '@/components/PageHeader/PageHeader';
import WhiteTable from '@/components/Table/WhiteTable';
import FloatingButton from '@/components/FloatingButton/FloatingButton';

export default {
    name: 'AdminPayments',

    components: {
        PageHeader,
        OverlayLoader,
        WhiteTable,
    },

    data() {
        return {
            payment: [],
            paymentLoaded: false,
        };
    },

    created() {
        this.getPayment();
    },

    methods: {
        getPayment() {
            this.API.admin.payments.show(this.$route.params.id)
                .then((response) => {
                    const data = response.data.data;
                    this.payment = data;
                    this.paymentLoaded = true;
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        unmarkAsExported() {
            this.API.admin.payments.unmarkAsExported(this.$route.params.id)
                .then(() => {
                    this.getPayment();
                })
                .catch((error) => {
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },
    },

    computed: {
        calculatedProvision() {
            const provision = (this.payment.order.calculated_price / 100) * this.payment.client.reseller.provision;
            // eslint-disable-next-line no-mixed-operators
            return Math.round(provision * 10 ** 2) / 10 ** 2;
        },
    },
};
</script>

<style scoped>
    .white-table {
        padding-top: 20px;
    }
</style>
